import React, { useState, useContext } from "react";
import {
    Container,
    Form,
    Button,
    FormGroup,
    Label,
    Col,
    Input,
    Row,
    Card,
    CardBody,
    CardFooter,
    CardHeader,
} from "reactstrap";

import firebase from "firebase/app";
import { UserContext } from "../context/UserContext";
import { Redirect, useHistory } from "react-router-dom";
import { toast } from "react-toastify";

export default function Signup() {
    const context = useContext(UserContext);
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const history = useHistory();

    const signIn = () => {
        firebase
            .auth()
            .signInWithEmailAndPassword(email, password)
            .then((res) => {
                console.log(res);
                //context.setUser({ email: res.user.email, uid: res.user.uid });
                /*firebase.database().ref('test').set({
                    "name": "testing"
                })*/
                localStorage.setItem("auth", new Date().getTime());
                history.push("/v1/admin/home");
            })
            .catch((error) => {
                console.log(error);
                toast(error.message, {
                    type: "error",
                });
            });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        signIn();
    };

    return (
        <Container className="text-center admin-hero">
            <Row style={{ "justifyContent": "center", "alignItems": "center", "height": "100vh","marginTop" : "40px" }}>
                <Col lg={4} className="">
                    <Card style={{boxShadow : "2px 2px 15px gray"}}>
                        <Form onSubmit={handleSubmit}>
                            <CardHeader className="">Signin here</CardHeader>
                            <CardBody>
                                <FormGroup row>
                                    <Label for="email" sm={3}>
                                        Email
                                    </Label>
                                    <Col sm={9}>
                                        <Input
                                            type="email"
                                            name="email"
                                            id="email"
                                            placeholder="provide your email"
                                            value={email}
                                            onChange={(e) => setEmail(e.target.value)}
                                        />
                                    </Col>
                                </FormGroup>
                                <FormGroup row>
                                    <Label for="password" sm={3}>
                                        Password
                                    </Label>
                                    <Col sm={9}>
                                        <Input
                                            type="password"
                                            name="password"
                                            id="password"
                                            placeholder="your password here"
                                            value={password}
                                            onChange={(e) => setPassword(e.target.value)}
                                        />
                                    </Col>
                                </FormGroup>
                            </CardBody>
                            <CardFooter>
                                <Button type="submit" block color="primary">
                                    Sign In
                                </Button>
                            </CardFooter>
                        </Form>
                    </Card>
                </Col>
            </Row>
        </Container>
    );
}
